export const CLIENT_COLORS = [
  { key: "rose", label: "Rosa", bg: "#FFE4E6", border: "#FDA4AF" },
  { key: "peach", label: "Pesca", bg: "#FFEDD5", border: "#FDBA74" },
  { key: "lemon", label: "Limone", bg: "#FEF9C3", border: "#FDE047" },
  { key: "mint", label: "Menta", bg: "#DCFCE7", border: "#86EFAC" },
  { key: "aqua", label: "Acqua", bg: "#CCFBF1", border: "#5EEAD4" },
  { key: "sky", label: "Cielo", bg: "#E0F2FE", border: "#7DD3FC" },
  { key: "lavender", label: "Lavanda", bg: "#EDE9FE", border: "#C4B5FD" },
  { key: "lilac", label: "Lilla", bg: "#FAE8FF", border: "#E9D5FF" },
  { key: "sand", label: "Sabbia", bg: "#F5F5DC", border: "#D6D3B0" },
  { key: "stone", label: "Grigio", bg: "#F1F5F9", border: "#CBD5E1" },
];

export const clientColor = (key) => CLIENT_COLORS.find((c) => c.key === key) || null;
